module.exports = __webpack_public_path__ + "static/media/g1vY.565f87e8.gif";